module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADwSURBVHgBndS7DcIwEAbg+08BiY4RsgGMAB2Eh7IBbICYgBmYADYgNIgORsgIGSF1bGKSKKCQp81f2D5bn3xuDEoyW4oJATYJ8bzfBwFpBM5KbgE65XWoZDy93fp+F2QAu0I9hMUPx4nGnZCgwtKeFuYe4j2SFk0x0sF1o7GM+aESUDpvfDM+C1OMYmGCUW5BF1egLq6FOrgRtmFF6mq1QRHziKo3Zmm8cbGWm2Q61xwFPRb1rXYhzxsE+AdVWtVFP9AEfaEpyuB8KV1mupigNMyMgynKYM0P0IkyiBcdTVGa/AdQtiRpW2T5noeQNPIGJ5Oz35bxS/YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/right.png
// module id = QWOe
// module chunks = 1